import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { i18WithParams as t } from '@shared/locale'
import { ButtonActions } from 'components-ui/src/button_actions/button_actions'
import { SimpleModal } from 'components-ui/src/simple_modal/simple_modal'
import { Spacer } from 'components-ui/src/spacer/spacer'
import { AssociatedContactClientDto } from 'service-api/src/types/api'

interface TDeleteDialogProps {
  contact: AssociatedContactClientDto
  onClose: () => void
  onConfirm: (contact: AssociatedContactClientDto) => Promise<void>
}

export const DeleteDialog = ({ contact, onClose, onConfirm }: TDeleteDialogProps) => {
  const onConfirmHandler = async () => onConfirm(contact)
  const onCloseHandler = async () => onClose()

  return (
    <SimpleModal open={true} onClose={onClose}>
      <div>
        <Typography variant="h6">{t('profile.contacts.deleteDialog.title')}</Typography>
        <Spacer height={3} />

        <Typography variant="body1">{t('profile.contacts.deleteDialog.content')}</Typography>
        <Spacer height={3} />

        <Stack direction="row" spacing={2}>
          <ButtonActions
            onAction={onConfirmHandler}
            onActionLabel={t('global.label.continue')}
            onCancel={onCloseHandler}
            onCancelLabel={t('global.label.cancel')}
            invertButtons
          />
        </Stack>
      </div>
    </SimpleModal>
  )
}
